/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ui/NG_BRANDSHAPE': {
    width: 16,
    height: 16,
    viewBox: '-1 -1 92 94',
    data: '<path pid="0" d="M84.44 25.46q-.81-1.76-1.77-3.42C75.75 10.31 63.07 2.28 48.74.56 35.49-1 22.94 3.13 14.34 12c-.74.74-1.45 1.52-2.11 2.31-.91 1-1.79 2.12-2.61 3.23s-1.47 2.07-2.13 3.16v.09C.37 34.32-1.83 49.73 1.56 62l.06.16a42 42 0 0 0 1.81 3.92c6.08 11.74 17 20.69 29.16 24a47.64 47.64 0 0 0 13.12 1.72 47.69 47.69 0 0 0 15.45-2.5s6.59-1.78 10.67-5.07 5.12-4 7.35-6.06c.81-.77 1.58-1.85 3-3.63 1.56-2.17 2.51-4.18 3.45-5.41l.09-.12c1.57-2.57 4-8.08 4.16-12.58a1.29 1.29 0 0 0 0-.39 1.27 1.27 0 0 0 .05-.34c.22-6.57-2.74-24.23-5.49-30.21"/>'
  }
})



// WEBPACK FOOTER //
// ./src/components/app-icons/ui/NG_BRANDSHAPE.js